// Written in this round about way for babel-transform-imports
import Redirect from "react-router/es/Redirect";

export default Redirect;


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/es/Redirect.js
// module id = 1129
// module chunks = 0